<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :backButtonEnable="false"
    ref="bom-bulk-update-list"
    :persistenceKey="'bill-of-materials-bulk-update-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "@/templates/transaction-list";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import { FeatureStorage } from "@/_services/storage";
import {
  BillOfMaterialsAllTabs,
  GetIndexByTabName,
} from "@/_models/tabdata/production/bill-of-materials-all-tabs";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
    };
  },
  computed: {
    setScreenConfig() {
      return {
        title: "Bill of Materials",
        ScreenName: "BOM Bulk Update",
        exportFileName: "BOM Bulk Update List",
        selectedIndex: GetIndexByTabName("Bulk Update"),
        tabs: BillOfMaterialsAllTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "BomBulkUpdateTransactionList",
              serverPaging: true,
              allowGrouping: false,
              key: "TransactionId",
              postProcessCallback: this.postProcessCallback,
              select: [
                "TransactionId",
                "Description",
                "BomsUpdatedCount",
                "BomsIncludedCount",
                "DateCreated",
                "CreatedBy",
                "DateCommitted",
                "CommittedBy",
                "Status",
              ]
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Bulk Update transactions",
                message: "Get Started, Add a Bulk Update",
              },
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/bill-of-materials-bulk-update/create",
                clickAction: {},
                buttonLocation: "left",
                disabled: !FeatureStorage.checkPermission(
                  "BulkBOMUpdate",
                  "create",
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              label: "Transaction ID",
              filterLabel: "Transaction ID",
              gridDataField: "TransactionId",
              filterDataField: "TransactionId",
              type: "Integer",
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              sortIndex: 0,
              sortOrder: "desc",
              minWidth: ColumnWidth.TransactionType.minWidth,
              width: ColumnWidth.TransactionType.width,
              filterIndex: 1,
              forceWidth: true,
            },
            {
              screenField: "ItemDescription",
              label: "Description",
              filterLabel: "Description",
              dataField: "Description",
              filterDataField: "Description",
              type: "Text",
              filterIndex: 2,
              allowHiding: false,
            },
            {
              screenField: "BomsUpdated",
              label: "BOMs Updated",
              dataField: "BomsUpdatedCount",
              width: 130,
              minWidth: 130,
              allowFiltering: false,
              cellTemplate: (data, info) => {
                const status = info.data.Status;
                const updated = info.data.BomsUpdatedCount;
                const included = info.data.BomsIncludedCount;
                if (status === "D" || status === "X") {
                  data.innerHTML = "&mdash;";
                } else {
                  data.innerHTML = `${
                    updated != null ? updated : 0
                  }&nbsp;/&nbsp;${included != null ? included : 0}`;
                }
              },
            },
            {
              screenField: "DateCreated",
              filterIndex: 3,
              minWidth: ColumnWidth.DateCreated.minWidth,
              width: ColumnWidth.DateCreated.width,
            },
            {
              screenField: "CreatedBy",
              filterIndex: 4,
              minWidth: ColumnWidth.CreatedBy.minWidth,
              width: ColumnWidth.CreatedBy.width,
            },
            {
              screenField: "DateIn",
              label: "Date Committed",
              filterLabel: "Date Committed",
              dataField: "DateCommitted",
              filterDataField: "DateCommitted",
              filterIndex: 5,
              minWidth: ColumnWidth.Date.minWidth,
              width: ColumnWidth.Date.width,
            },
            {
              screenField: "CommittedBy",
              label: "Committed By",
              filterLabel: "Committed By",
              dataField: "CommittedBy",
              filterDataField: "CommittedBy",
              filterIndex: 6,
              minWidth: ColumnWidth.CreatedBy.minWidth,
              width: ColumnWidth.CreatedBy.width,
            },
            {
              screenField: "OrderStatus",
              filterIndex: 7,
              gridDataField: "FriendlyStatus",
              filterDataField: "Status",
              width: ColumnWidth.Status.width + 50,
              minWidth: ColumnWidth.Status.minWidth + 50,
              dataSourceConfig: {
                data: [
                  { key: "D", value: "Draft" },
                  { key: "C", value: "Committed" },
                  { key: "CE", value: "Committed with Errors" },
                  { key: "X", value: "Cancelled" },
                ],
              },
              valueExpr: "key",
              displayExpr: "value",
              // cellTemplate: (data, info) => {
              //   const cls = this.statusBadgeClass(info.data.Status);
              //   const label = this.statusLabel(info.data.Status);
              //   data.innerHTML = `<span class="bom-bulk-status-badge ${cls}">${label}</span>`;
              // },
            },
          ],
        },
      };
    },
  },
  created() {},
  methods: {
    statusBadgeClass(status) {
      return (
        {
          D: "badge-secondary",
          C: "badge-success",
          CE: "badge-warning",
          X: "badge-danger",
        }[status] || "badge-secondary"
      );
    },
    statusLabel(status) {
      return (
        {
          D: "Draft",
          C: "Committed",
          CE: "Committed with Errors",
          X: "Cancelled",
        }[status] || status
      );
    },
    rowClickCallBack(e) {
      if (
        e.rowType === "data" &&
        e.column.screenField !== "Status" &&
        e.column.screenField !== "GridRecordPDFView" &&
        e.column.screenField !== "GridRecordPrint" &&
        e.column.screenField !== "GridRecordEllipsisMenu" &&
        e.column.type !== "selection"
      ) {
        const { TransactionId, Status } = e.data;
        if (Status.trim() === "D") {
          this.$router.push({
            name: "bill-of-materials-bulk-update-edit",
            params: { id: TransactionId },
          });
        } else {
          this.$router.push({
            name: "bill-of-materials-bulk-update-review",
            params: { id: TransactionId },
          });
        }
      }
    },
    postProcessCallback(data) {
      return data.map((item) => {
        return {
          ...item,
          FriendlyStatus: this.statusLabel(item.Status.trim()),
        };
      });
    },
  },
};
</script>

<style lang="scss">
.bom-bulk-status-badge {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: 600;
  white-space: nowrap;

  &.badge-secondary {
    background-color: #6c757d;
    color: #fff;
  }

  &.badge-success {
    background-color: #198754;
    color: #fff;
  }

  &.badge-warning {
    background-color: #ffc107;
    color: #212529;
  }

  &.badge-danger {
    background-color: #dc3545;
    color: #fff;
  }
}
</style>
